import React from 'react';
import DownloadableReportTable from '../DownloadableReportTable';
import { getService } from '@Client/runner.hooks/useService';
import FlowModelType from '@Shared.Angular/@types/core/contracts/constants/flowModelType';

const FlowModelReportsTab = () => {
  const APP_CONFIG = getService('APP_CONFIG');
  const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const reports = [
    APP_CONFIG.allowProcessMap && APP_CONFIG.allowWorkflow
      ? {
          name: 'Flow Models Report',
          description: 'Basic information about all Flow Models.',
          url: APP_CONFIG.apiBaseUrl + 'reports/flowModels/csvV2',
          parameters: {
            userTimeZone: userTimeZone
          }
        }
      : null,
    APP_CONFIG.allowProcessMap
      ? {
          name: 'Process Maps Report',
          description: 'Basic information about Process Maps.',
          url: APP_CONFIG.apiBaseUrl + 'reports/flowModels/csvV2',
          parameters: {
            userTimeZone: userTimeZone,
            type: FlowModelType.ProcessMap
          }
        }
      : null,
    APP_CONFIG.allowProcessMap
      ? {
          name: 'Process Usage Report',
          description:
            'How many times Process Maps have been viewed and commented on.',
          url: APP_CONFIG.apiBaseUrl + 'reports/processMaps/usage/csvV2',
          parameters: {
            userTimeZone: userTimeZone
          }
        }
      : null,
    APP_CONFIG.allowWorkflow
      ? {
          name: 'Workflows Report',
          description: 'Basic information about Workflows.',
          url: APP_CONFIG.apiBaseUrl + 'reports/flowModels/csvV2',
          parameters: {
            userTimeZone: userTimeZone,
            type: FlowModelType.Workflow
          }
        }
      : null
  ].filter(Boolean);
  return (
    <div className="flow-model-reports">
      <DownloadableReportTable reports={reports} />
    </div>
  );
};

export default FlowModelReportsTab;
